import { render, staticRenderFns } from "./core-drawer.vue?vue&type=template&id=1fb3ad3a&"
import script from "./core-drawer.vue?vue&type=script&lang=js&"
export * from "./core-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports